var _defs, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-76a46143-b10b-4cb6-8b56-a997bb49e008",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-14be91c5-1456-4ae8-a759-68a14a4cbc7a{fill:#ec2227;}.uuid-b82fbfd5-b39e-4ff3-ae53-add8e6738c80{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-b82fbfd5-b39e-4ff3-ae53-add8e6738c80",
    x: -0.5,
    y: -0.5,
    width: 513,
    height: 513
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-14be91c5-1456-4ae8-a759-68a14a4cbc7a",
    d: "m156.19,299.24h89.09l-45.75,85.76h-87.65l44.31-85.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m251.31,121.33l149.09,263.67h-104.07l-97.06-170.62,52.03-93.06h0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAme);
export default __webpack_public_path__ + "static/media/icon_ame.351c0d99464d66bdcd339b7d26ada6c2.svg";
export { ForwardRef as ReactComponent };